import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { parse } from 'qs'
import { Box, Container, Typography, Dialog } from '@mui/material'

import { withStyles } from '@mui/styles'
import { ThemeButton } from '../../../../ui'
import { fetchInstallers } from '../../slices'
import { PrescriptorInstallersTable } from '../table'
import { PrescriptorInstallersFilter } from '../filter'
import { PrescriptorInstallersDialog } from '../dialog'
import { INSTALLERS_DEFAULT_QUERY } from '../../constants'
import { prescriptorInstallersDashboardStyles } from './prescriptor-installers-dashboard.styles'

export const PrescriptorInstallersDashboard = withStyles(prescriptorInstallersDashboardStyles)(({
  classes,
}) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const prescriptorId = useSelector((state) => state.global.empresa_id)
  const url = useLocation().search
  const urlSearchParams = parse(url.split('?')[1])
  const searchParams = { ...INSTALLERS_DEFAULT_QUERY, ...urlSearchParams }

  const [createDialogOpen, setCreateDialogOpen] = useState(false)

  useEffect(() => {
    if (prescriptorId) {
      dispatch(fetchInstallers(searchParams, prescriptorId))
    }
  }, [url, prescriptorId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Container className={classes.container}>
        <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h4" color="textSecondary">
            {intl.formatMessage({ id: 'pages.prescriptor.installers.title' })}
          </Typography>
          <ThemeButton color="primary" onClick={() => setCreateDialogOpen(true)}>
            + Nuevo instalador
          </ThemeButton>
        </Box>

        <Box mb={3}>
          <PrescriptorInstallersFilter search={searchParams} onChange={() => {}} />
        </Box>

        <PrescriptorInstallersTable />
      </Container>

      <Dialog
        open={createDialogOpen}
        onClose={() => setCreateDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <PrescriptorInstallersDialog installer={null} onClose={() => setCreateDialogOpen(false)} />
      </Dialog>
    </Box>
  )
})
